// DEVIATION from the plan: relative imports instead of the '@' alias, for the
// same reason as useGeneratedCourse.ts — jest has no moduleNameMapper for '@'
// and jest.config.js may not be touched. See useGeneratedCourse.ts for detail.
import ChessRestClient from '../../Api/ChessRestClient';
import {getLocalStorage} from '../../Utils/CommonUtils';
import {useMutation, UseMutationResult} from '@tanstack/react-query';

import {ProgressPayload} from './types';

export async function postCourseProgress(payload: ProgressPayload) {
  const token = await getLocalStorage('access_token');
  const response = await ChessRestClient.post('/lms/v1/user-progress', payload, {
    headers: {Authorization: `Bearer ${token}`},
  });
  return response.data;
}

export function useCourseProgress(): UseMutationResult<
  unknown,
  Error,
  ProgressPayload
> {
  return useMutation<unknown, Error, ProgressPayload>(postCourseProgress);
}
